// The install prompt (WEB-10, design system 06-web-and-app): a Toast-shaped bar at the bottom,
// "Add Wahala to your home screen." with Add (carry) and Not now (ghost). Only where the browser
// offers an install (beforeinstallprompt, caught at boot by lib/install), never inside the Lagos Life
// frame, never when already installed, never during play; once per visit, after the player's first
// interaction. iPhone and iPad Safari never offer an install, so there the bar says how (Share, then
// Add to Home Screen) with one OK. Every other browser gets the Menu's Get the app (InstallSheet),
// which is there any time.
import { useEffect, useState } from 'react';
import { promptInstall, useInstallWay } from '../lib/install';
import { S } from '../strings';

export { isIosSafari } from '../lib/install';

const SEEN = 'wahala.installAsked';
let shownThisVisit = false;

function seen(): boolean {
  if (shownThisVisit) return true;
  try {
    return sessionStorage.getItem(SEEN) === '1';
  } catch {
    return false;
  }
}

function markSeen(): void {
  shownThisVisit = true;
  try {
    sessionStorage.setItem(SEEN, '1');
  } catch {
    // storage blocked: the module flag still keeps it to once
  }
}

export function InstallBar({ hidden }: { hidden: boolean }) {
  const way = useInstallWay();
  const [touched, setTouched] = useState(false);
  const [open, setOpen] = useState(false);
  const offered = way === 'prompt' || way === 'ios';

  useEffect(() => {
    if (seen()) return;
    const onTouch = () => setTouched(true);
    window.addEventListener('pointerdown', onTouch, { once: true, capture: true });
    window.addEventListener('keydown', onTouch, { once: true, capture: true });
    return () => {
      window.removeEventListener('pointerdown', onTouch, { capture: true });
      window.removeEventListener('keydown', onTouch, { capture: true });
    };
  }, []);

  useEffect(() => {
    // never on top of the notifications ask (PushAsk) or the install sheet
    if (offered && touched && !seen() && !document.querySelector('.push-ask, .install-sheet')) {
      markSeen();
      setOpen(true);
    }
  }, [offered, touched]);

  if (!open || hidden || !offered) return null;
  const close = () => setOpen(false);
  if (way === 'ios')
    return (
      <section className="install-bar" aria-label={S.install.text}>
        <div className="wh-toast wh-toast--callout install-bar__toast">
          <span className="install-bar__text">{S.install.ios}</span>
          <button type="button" className="wh-btn wh-btn--carry wh-btn--sm" onClick={close}>
            {S.install.ok}
          </button>
        </div>
      </section>
    );
  return (
    <section className="install-bar" aria-label={S.install.text}>
      <div className="wh-toast wh-toast--callout install-bar__toast">
        <span className="install-bar__text">{S.install.text}</span>
        <button
          type="button"
          className="wh-btn wh-btn--carry wh-btn--sm"
          onClick={() => {
            close();
            void promptInstall();
          }}
        >
          {S.install.add}
        </button>
        <button type="button" className="wh-btn wh-btn--ghost wh-btn--sm" onClick={close}>
          {S.install.later}
        </button>
      </div>
    </section>
  );
}
